import React, { createContext, useState } from 'react'


// const LanguageContext = createContext({
//     language: "EN",
//     updateLanguage: () => {},
// })


 const LanguageProvider = ({ language, children }) => {
   // const { lang } = useAuth()
    language =   (window.localStorage.getItem('language')===null?"EN":window.localStorage.getItem('language'))
    const [currentLanguage, setCurrentLanguage] = useState(language)

    const handleUpdateLanguage = (update) => {
       // const marged = merge({}, currentLanguage, update)
       // update = currentLanguage
       localStorage.removeItem('language') // Eliminar la sesion del lenguage actual 
       localStorage.setItem('language', update) // Colocar el nuevo lenguage
        setCurrentLanguage(update)
        
    }

    return (
        <LanguageContext.Provider
            value={{
                language: currentLanguage,
                updateLanguage: handleUpdateLanguage,
            }}
        >
            {children}
        </LanguageContext.Provider>
    )
}
export default LanguageProvider

export const LanguageContext  = createContext({
    language: "EN",
    updateLanguage: () => {},
})